export default {
	person: "Persona",
	journeyStage: "Etapa",
	since: "Desde",
	createAssignment: "Asignar Etapa",
	assignNewPosition: "Asignar Etapa",
	confirmDeleteMessage: "¿Está seguro de que desea eliminar la asignación \"{name}\"? Esta acción no se puede deshacer.",
	journeyProgressionInfo: "Solo se pueden seleccionar etapas superiores al nivel actual ({currentLevel}).",
	createSuccess: "¡Asignación creada con éxito!",
	createError: "Error al crear asignación",
	deleteSuccess: "¡Asignación eliminada con éxito!",
	deleteError: "Error al eliminar asignación",
};
